import { render, staticRenderFns } from "./AddAgent.vue?vue&type=template&id=be847f2e&scoped=true&"
import script from "./AddAgent.vue?vue&type=script&lang=js&"
export * from "./AddAgent.vue?vue&type=script&lang=js&"
import style0 from "./AddAgent.vue?vue&type=style&index=0&id=be847f2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be847f2e",
  null
  
)

export default component.exports